const ITEMS = [
  { text: "Smart Townships", cls: "text-white/70" },
  { text: "Ultra Luxury Home Automation", cls: "text-[#00F0FF]/80" },
  { text: "Hotel & Office AIoT", cls: "text-white/70" },
  { text: "Native LuxeRay App", cls: "text-white/70" },
  { text: "Biometric OLED Switches", cls: "text-white/70" },
];

export default function Marquee() {
  const track = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-white/10 py-4 bg-[#061536]/60 overflow-hidden" data-testid="marquee-verticals">
      <div className="mq-track font-disp text-2xl uppercase tracking-widest text-white/40">
        {track.map((item, i) => (
          <span key={i} className={`mx-6 ${item.cls}`}>
            · {item.text}
          </span>
        ))}
      </div>
    </div>
  );
}
